import { jsx as _jsx } from "react/jsx-runtime";
import { generateViewsComponent } from "../../../../../../helpers/views.js";
import { PanelAccommodationProvider } from "./context.js";
import PanelAccommodationDesktop from "./views/desktop/index.js";
import PanelAccommodationMobile from "./views/mobile/index.js";
const PanelAccommodationView = generateViewsComponent(PanelAccommodationDesktop, PanelAccommodationMobile);
const PanelAccommodation = (props)=>/*#__PURE__*/ _jsx(PanelAccommodationProvider, {
        rooms: props.rooms,
        people: props.people,
        onChange: props.onChange,
        children: /*#__PURE__*/ _jsx(PanelAccommodationView, {
            ...props
        })
    });
export default PanelAccommodation;

//# sourceMappingURL=index.js.map